import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'lib-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss'],
})
export class DialogConfirmComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogConfirmComponentData
  ) {}
  slideControl: FormControl;
  ngOnInit(): void {
    if (this.data.additionalBoolean) {
      this.slideControl = new FormControl(this.data.additionalBoolean.value);
    }
  }

  closeDialog() {
    this.dialogRef.close(false);
  }

  handleConfirm() {
    const returnValue = this.data.additionalBoolean ? { additionalBoolean: this.slideControl.value } : true;
    this.dialogRef.close(returnValue);
  }
}

export interface DialogConfirmComponentData {
  title: string;
  descriptionHtml: string;
  confirmBtn: string;
  closeIconPath?: string;
  additionalBoolean?: { label: string; value: boolean; type: 'slide' };
}
